"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sms = require("@/api/sms");
var commFilter = _interopRequireWildcard(require("@/filters/commFilter"));
var _index = _interopRequireDefault(require("../../../appSetting/wxAccount/wxTemplate/index"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'TableList',
  props: {
    copy: {
      type: Object,
      default: null
    },
    dump: {
      type: Object,
      default: null
    },
    query: {
      type: Object,
      default: null
    },
    sms: {
      type: Object,
      default: null
    },
    accountInfo: {
      type: Object,
      default: null
    }
  },
  components: {
    Template: _index.default
  },
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        status: '3',
        type: 'sms'
      },
      columns2: [],
      isSms: false,
      // 是否开通短信
      isDump: false,
      // 是否开通电子面单,是否开通物流查询
      isCopy: false,
      // 是否开通商品采集
      modals: false,
      loading: false,
      formInlineDump: {
        tempId: '',
        sign: '',
        com: '',
        toName: '',
        toTel: '',
        siid: '',
        toAddress: '',
        type: ''
      },
      ruleInline: {
        sign: [{
          required: true,
          message: '请输入短信签名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        com: [{
          required: true,
          message: '请选择快递公司',
          trigger: 'change'
        }],
        tempId: [{
          required: true,
          message: '请选择打印模板',
          trigger: 'change'
        }],
        toName: [{
          required: true,
          message: '请输寄件人姓名',
          trigger: 'blur'
        }],
        toTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        siid: [{
          required: true,
          message: '请输入云打印机编号',
          trigger: 'blur'
        }],
        toAddress: [{
          required: true,
          message: '请输寄件人地址',
          trigger: 'blur'
        }]
      },
      tempImg: '',
      // 图片
      exportTempList: [],
      // 电子面单模板
      exportList: [],
      // 快递公司列表
      formInline: {
        phone: '',
        code: '',
        sign: ''
      },
      ruleInlineSign: {
        sign: [{
          required: true,
          message: '请输入短信签名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      cutNUm: '获取验证码',
      canClick: true
    };
  },
  watch: {
    sms: function sms(n) {
      if (n.open === 1) this.getList();
    }
  },
  mounted: function mounted() {
    if (this.$route.query.type) this.tableFrom.type = this.$route.query.type;
    if (this.sms.open === 1) this.getList();
  },
  methods: {
    editSign: function editSign() {
      this.formInline.account = this.accountInfo.account;
      this.formInline.sign = this.accountInfo.sms.sign;
      this.formInline.phone = this.accountInfo.phone;
      this.dialogVisible = true;
    },
    //修改签名
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _sms.smsSignApi)(_this.formInline).then(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _this.$message.success('修改签名之后一号通需要审核过后通过!');
                    _this.dialogVisible = false;
                    _this.$refs[formName].resetFields();
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          return false;
        }
      });
    }),
    // 短信验证码
    cutDown: function cutDown() {
      var _this2 = this;
      if (this.formInline.phone) {
        if (!this.canClick) return;
        this.canClick = false;
        this.cutNUm = 60;
        var data = {
          phone: this.formInline.phone,
          types: 1
        };
        (0, _sms.captchaApi)(data).then(/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this2.$message.success(res.msg);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
        var time = setInterval(function () {
          _this2.cutNUm--;
          if (_this2.cutNUm === 0) {
            _this2.cutNUm = '获取验证码';
            _this2.canClick = true;
            clearInterval(time);
          }
        }, 1000);
      } else {
        this.$message.warning('请填写手机号!');
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs['formInline'].resetFields();
    },
    // 首页去开通
    onOpenIndex: function onOpenIndex(val) {
      this.tableFrom.type = val;
      switch (val) {
        case 'sms':
          this.isSms = true;
          break;
        case 'expr_dump':
          this.openDump();
          break;
        default:
          this.openOther();
          break;
      }
    },
    // 开通其他
    openOther: function openOther() {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u5F00\u901A".concat(commFilter.onePassTypeFilter(this.tableFrom.type), "\u5417?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // this.handleSubmitDump('formInlineDump');
        (0, _sms.serviceOpenApi)({
          type: _this3.tableFrom.type
        }).then(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _this3.$message.success('开通成功!');
                  _this3.getList();
                  _this3.$emit('openService');
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 开通电子面单
    openDump: function openDump() {
      this.exportTempAllList();
      this.isDump = true;
    },
    // 物流公司
    exportTempAllList: function exportTempAllList() {
      var _this4 = this;
      (0, _sms.expressAllApi)({
        type: 'elec'
      }).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this4.exportList = res;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 快递公司选择
    onChangeExport: function onChangeExport(val) {
      this.formInlineDump.tempId = '';
      this.exportTemp(val);
    },
    // 电子面单模板
    exportTemp: function exportTemp(val) {
      var _this5 = this;
      (0, _sms.exportTempApi)({
        com: val
      }).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this5.exportTempList = res.data.data || [];
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x5) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    onChangeImg: function onChangeImg(item) {
      var _this6 = this;
      this.exportTempList.map(function (i) {
        if (i.temp_id === item) _this6.tempImg = i.pic;
      });
    },
    handleSubmitDump: function handleSubmitDump(name) {
      var _this7 = this;
      this.formInlineDump.type = this.tableFrom.type;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this7.loading = true;
          (0, _sms.serviceOpenApi)(_this7.formInlineDump).then(/*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    _this7.$emit('openService');
                    _this7.$message.success('开通成功!');
                    _this7.getList();
                    _this7.loading = false;
                  case 1:
                    return _context6.a(2);
                }
              }, _callee6);
            }));
            return function (_x6) {
              return _ref6.apply(this, arguments);
            };
          }()).catch(function () {
            _this7.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    onChangeType: function onChangeType() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this8 = this;
      this.listLoading = true;
      (0, _sms.smsLstApi)(this.tableFrom).then(function (res) {
        _this8.tableData.data = res.data;
        if (_this8.tableFrom.type == 'sms') {
          var obj = new Object();
          var newArr = new Array();
          res.data.forEach(function (item) {
            obj = item;
            switch (item.status) {
              case 0:
                obj.status = '发送中';
                break;
              case 1:
                obj.status = '成功';
                break;
              case 2:
                obj.status = '失败';
                break;
              case 3:
                obj.status = '全部';
                break;
            }
            newArr.push(obj);
            _this8.tableData.data = newArr;
          });
        }
        _this8.tableData.total = res.count;
        switch (_this8.tableFrom.type) {
          case 'sms':
            _this8.columns2 = [{
              title: '手机号',
              key: 'phone',
              minWidth: 100
            }, {
              title: '模板内容',
              key: 'content',
              minWidth: 590
            }, {
              title: '发送时间',
              key: 'add_time',
              minWidth: 150
            }
            // {
            //   title: '状态',
            //   key: 'status',
            //   minWidth: 100
            // }
            ];
            break;
          case 'expr_dump':
            _this8.columns2 = [
            // {
            //   title: '订单号',
            //   key: 'order_id',
            //   minWidth: 150
            // },
            {
              title: '发货人',
              key: 'from_name',
              minWidth: 120
            }, {
              title: '收货人',
              key: 'to_name',
              minWidth: 120
            }, {
              title: '快递单号',
              key: 'num',
              minWidth: 120
            }, {
              title: '快递公司编码',
              key: 'code',
              minWidth: 120
            }, {
              title: '状态',
              key: '_resultcode',
              minWidth: 100
            }, {
              title: '打印时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;
          case 'expr_query':
            _this8.columns2 = [{
              title: '快递单号',
              key: 'content',
              minWidth: 120
            }, {
              title: '快递公司编码',
              key: 'code',
              minWidth: 120
            }, {
              title: '状态',
              key: '_resultcode',
              minWidth: 120
            }, {
              title: '添加时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;
          default:
            _this8.columns2 = [{
              title: '复制URL',
              key: 'url',
              minWidth: 400
            }, {
              title: '请求状态',
              key: '_resultcode',
              minWidth: 120
            }, {
              title: '添加时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;
        }
        _this8.listLoading = false;
      }).catch(function (res) {
        _this8.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};